/* no babel so we have to use old js syntax */
window.Popper = require('popper.js');
require('bootstrap');

import "@fontsource/lato/latin.css";
import "@fontsource/heebo/latin.css";

import Masonry from 'masonry-layout'


;$(function() {

  var elem = document.querySelector('.row.images');
  var msnry = new Masonry( elem, {
    // options
    itemSelector: 'div.image',
    percentPosition: true
  });


  var $hamburger = $(".hamburger");
  $hamburger.on("click", function(e) {
    $hamburger.toggleClass("is-active");
    // Do something else, like open/close menu
  });

});



//////////////////
// WEBPACK FOOTER
// ./js/theme.js
// module id = 4
// module chunks = 0